<div *ngIf="isDataLoaded" class="bg-light">

    <!-- Breadcrumb -->
    <div class="store-breadcrumb">
        <div class="container">
            <a href="/">Home</a>
            <span class="sep"><svg class="icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg></span>
            <span class="current">All Seasonals</span>
        </div>
    </div>

    <!-- Main Content -->
    <main class="all-stores-page py-5">
        <div class="container">
            <div class="stores-layout">
                <!-- Left Sidebar -->
                <aside class="stores-sidebar">
                    <div class="sidebar-about">
                        <h3 class="sidebar-title">About Seasonals</h3>
                        <div class="sidebar-desc-wrapper">
                            <p class="sidebar-desc">
                                Discover seasonal events, special occasions, and limited-time savings at DealsZo.
                                Browse our seasonal offers to find relevant coupons and deals throughout the year.
                            </p>
                        </div>
                    </div>

                    <div class="sidebar-about seasonal-category-links">
                        <h3 class="sidebar-title">Top Stores</h3>
                        <ul class="trending-list">
                            <li *ngFor="let brand of topBrands.slice(0, 6)">
                                <a [href]="'/' + brand.SeoName + '-coupons/'"><span
                                        class="merchant-name">{{ brand.StoreName }}</span></a>
                            </li>
                        </ul>
                    </div>

                    <div class="sidebar-about seasonal-category-links">
                        <h3 class="sidebar-title">Top Categories</h3>
                        <ul class="trending-list">
                            <li *ngFor="let category of topCategories.slice(0, 6)">
                                <a [href]="'/coupons/' + category.CategorySEOName + '/'"><span
                                        class="merchant-name">{{ category.CategoryName }}</span></a>
                            </li>
                        </ul>
                    </div>
                </aside>

                <!-- Main Content Area -->
                <div class="stores-content-area">
                    <div class="section-header">
                        <h2>{{ seasonalMeta.PageH1Title ? (seasonalMeta.PageH1Title |
                            replaceMetaDate:today) : 'All Seasonals' }}</h2>
                        <span class="coupon-count">{{ seasonals.length }} Seasonal Offers</span>
                    </div>

                    <!-- Seasonal Grid: intentionally no alphabetical filter -->
                    <div class="stores-grid" id="seasonals-grid">
                        <a *ngFor="let seasonal of seasonals"
                            [href]="seasonal.SeasonalSEOName ? '/seasonal/' + seasonal.SeasonalSEOName + '/' : '#'"
                            class="store-item-card" [attr.data-name]="seasonal.SeasonalName">
                            <div class="store-card-info">
                                <h3 class="store-name">{{ seasonal.SeasonalName }}</h3>
                                <p class="coupon-count" *ngIf="seasonal.CouponTitle">{{ seasonal.CouponTitle }}</p>
                                <p class="coupon-count" *ngIf="seasonal.StoreName">{{ seasonal.StoreName }}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>